module.exports = __webpack_public_path__ + "img/Jutta-Nordsiek_1301x974[1].5bd9057.jpg";